import {
 
  
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_SUCCESS,
  PROJECT_LIST_FAIL,
  PROJECT_LIST_RESET,
  
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAIL,
  GET_PROJECT_RESET,
 
  ADD_PROJECT_REQUEST,
  ADD_PROJECT_SUCCESS,
  ADD_PROJECT_FAIL,
  ADD_PROJECT_RESET,
  
  RENAME_PROJECT_REQUEST,
  RENAME_PROJECT_SUCCESS,
  RENAME_PROJECT_FAIL,
  RENAME_PROJECT_RESET,
  
  DELETE_PROJECT_REQUEST ,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAIL,
  DELETE_PROJECT_RESET,
  
  
  ADD_PROJECT_LINK_REQUEST,
  ADD_PROJECT_LINK_SUCCESS,
  ADD_PROJECT_LINK_FAIL,
  ADD_PROJECT_LINK_RESET,
  
  EDIT_PROJECT_LINK_REQUEST,
  EDIT_PROJECT_LINK_SUCCESS,
  EDIT_PROJECT_LINK_FAIL,
  EDIT_PROJECT_LINK_RESET,
  
  DELETE_PROJECT_LINK_REQUEST,
  DELETE_PROJECT_LINK_SUCCESS,
  DELETE_PROJECT_LINK_FAIL,
  DELETE_PROJECT_LINK_RESET,
  
  ADD_PROJECT_TASK_REQUEST,
  ADD_PROJECT_TASK_SUCCESS,
  ADD_PROJECT_TASK_FAIL,
  ADD_PROJECT_TASK_RESET,
  
  EDIT_PROJECT_TASK_REQUEST,
  EDIT_PROJECT_TASK_SUCCESS,
  EDIT_PROJECT_TASK_FAIL,
  EDIT_PROJECT_TASK_RESET,
  
  DELETE_PROJECT_TASK_REQUEST,
  DELETE_PROJECT_TASK_SUCCESS,
  DELETE_PROJECT_TASK_FAIL,
  DELETE_PROJECT_TASK_RESET,
  
  CLEAR_PROJECT_DONE_TASKS_REQUEST,
  CLEAR_PROJECT_DONE_TASKS_SUCCESS,
  CLEAR_PROJECT_DONE_TASKS_FAIL,
  CLEAR_PROJECT_DONE_TASKS_RESET,
  
  ADD_PROJECT_LIST_REQUEST,
  ADD_PROJECT_LIST_SUCCESS,
  ADD_PROJECT_LIST_FAIL,
  ADD_PROJECT_LIST_RESET,
  
  
  RENAME_PROJECT_LIST_REQUEST,
  RENAME_PROJECT_LIST_SUCCESS,
  RENAME_PROJECT_LIST_FAIL,
  RENAME_PROJECT_LIST_RESET,
  
  ADD_PROJECT_LIST_ITEM_REQUEST,
  ADD_PROJECT_LIST_ITEM_SUCCESS,
  ADD_PROJECT_LIST_ITEM_FAIL,
  ADD_PROJECT_LIST_ITEM_RESET,
  
  TOGGLE_PROJECT_LIST_ITEM_REQUEST,
  TOGGLE_PROJECT_LIST_ITEM_SUCCESS,
  TOGGLE_PROJECT_LIST_ITEM_FAIL,
  TOGGLE_PROJECT_LIST_ITEM_RESET,
  
  DELETE_PROJECT_LIST_ITEM_REQUEST,
  DELETE_PROJECT_LIST_ITEM_SUCCESS,
  DELETE_PROJECT_LIST_ITEM_FAIL,
  DELETE_PROJECT_LIST_ITEM_RESET,
  
  DELETE_PROJECT_LIST_REQUEST,
  DELETE_PROJECT_LIST_SUCCESS,
  DELETE_PROJECT_LIST_FAIL,
  DELETE_PROJECT_LIST_RESET,
  
  
  SAVE_PROJECT_NOTE_REQUEST,
  SAVE_PROJECT_NOTE_SUCCESS,
  SAVE_PROJECT_NOTE_FAIL,
  SAVE_PROJECT_NOTE_RESET,
  



} from "../constants/projectsConstants";

export const projectsListReducer = (
  state = { loading: false, status:"", data: []  },
  action
) => {
  switch (action.type) {
    case PROJECT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case PROJECT_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case PROJECT_LIST_FAIL:
      return {
        data:  [],
        loading: false,
        error: action.payload,
        status:"error"
      };
    case PROJECT_LIST_RESET:
      return { loading: false, data:  [], status:""  };

    default:
      return state;
  }
};
export const currentProjectReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case GET_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case GET_PROJECT_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case GET_PROJECT_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case GET_PROJECT_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const addProjectReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case ADD_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_PROJECT_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_PROJECT_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_PROJECT_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const renameProjectReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case RENAME_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case RENAME_PROJECT_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case RENAME_PROJECT_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case RENAME_PROJECT_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const deleteProjectReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case DELETE_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case DELETE_PROJECT_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case DELETE_PROJECT_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case DELETE_PROJECT_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const addProjectLinkReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case ADD_PROJECT_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_PROJECT_LINK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_PROJECT_LINK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_PROJECT_LINK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const editProjectLinkReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case EDIT_PROJECT_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case EDIT_PROJECT_LINK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case EDIT_PROJECT_LINK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case EDIT_PROJECT_LINK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const deleteProjectLinkReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case DELETE_PROJECT_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case DELETE_PROJECT_LINK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case DELETE_PROJECT_LINK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case DELETE_PROJECT_LINK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const addProjectTaskReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case ADD_PROJECT_TASK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_PROJECT_TASK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_PROJECT_TASK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_PROJECT_TASK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const editProjectTaskReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case EDIT_PROJECT_TASK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case EDIT_PROJECT_TASK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case EDIT_PROJECT_TASK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case EDIT_PROJECT_TASK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const deleteProjectTaskReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case DELETE_PROJECT_TASK_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case DELETE_PROJECT_TASK_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case DELETE_PROJECT_TASK_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case DELETE_PROJECT_TASK_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const clearProjectDoneTaskReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case CLEAR_PROJECT_DONE_TASKS_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case CLEAR_PROJECT_DONE_TASKS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case CLEAR_PROJECT_DONE_TASKS_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case CLEAR_PROJECT_DONE_TASKS_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const addProjectListReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case ADD_PROJECT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_PROJECT_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_PROJECT_LIST_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_PROJECT_LIST_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const renameProjectListReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case RENAME_PROJECT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case RENAME_PROJECT_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case RENAME_PROJECT_LIST_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case RENAME_PROJECT_LIST_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const addProjectListItemReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case ADD_PROJECT_LIST_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_PROJECT_LIST_ITEM_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_PROJECT_LIST_ITEM_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_PROJECT_LIST_ITEM_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const toggleProjectListItemReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case TOGGLE_PROJECT_LIST_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case TOGGLE_PROJECT_LIST_ITEM_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case TOGGLE_PROJECT_LIST_ITEM_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case TOGGLE_PROJECT_LIST_ITEM_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const deleteProjectListItemReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case DELETE_PROJECT_LIST_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case DELETE_PROJECT_LIST_ITEM_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case DELETE_PROJECT_LIST_ITEM_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case DELETE_PROJECT_LIST_ITEM_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const deleteProjectListReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case DELETE_PROJECT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case DELETE_PROJECT_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case DELETE_PROJECT_LIST_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case DELETE_PROJECT_LIST_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};
export const saveProjectNoteReducer = (
  state = { loading: false, status:"", data: {}  },
  action
) => {
  switch (action.type) {
    case SAVE_PROJECT_NOTE_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case SAVE_PROJECT_NOTE_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case SAVE_PROJECT_NOTE_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case SAVE_PROJECT_NOTE_RESET:
      return { loading: false, data:  {}, status:""  };

    default:
      return state;
  }
};